module.exports = __webpack_public_path__ + "static/headerRightBg375-b237b94cc2245bb9a667cab96a670d97.png";